export const envelopeKey = 'results';
export const paginationKey = 'pagination';

export const isInEnvelope = (res, key) => res && Object.keys(res).includes(key);

export const hasPagination = (res) =>
  res && (Object.keys(res).includes(paginationKey) || (res.count !== undefined && res.results !== undefined));

export const unwrapFromEnvelope = (res, key) => res[key];

export const toPaginatedResults: (res: any) => [any, any] = (res) => [res[envelopeKey], res[paginationKey]];
